module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_9006.189fe2f6.png";